import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import StopIcon from '@material-ui/icons/Stop';
import TreeItem from '@material-ui/lab/TreeItem';
import { DataContext } from './DataContext';

const useStyles = makeStyles({
    root: {
        flex: 1,
        maxWidth: 400,
    },
    label: {
        paddingTop: 2.5,
        paddingBottom: 2.5,
    },
});

export default function CurrentMachineSelection() {
    const classes = useStyles();
    const data = useContext(DataContext);

    return (
        <TreeView
        className={classes.root}
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        defaultEndIcon={<StopIcon fontSize='small' />}
        >
            <TreeItem 
                nodeId="1" 
                label={`Company : ${data.company}`} 
                className={classes.label}
                onClick={() => {
                    data.setDashboardSelectState(4);
                }} />
            <TreeItem 
                nodeId="2" 
                label={`Database : ${data.database}`} 
                className={classes.label}
                onClick={() => {
                    data.setDashboardSelectState(5);
                }} />
            <TreeItem 
                nodeId="3" 
                label={`Area : ${data.area}`} 
                className={classes.label}
                onClick={() => {
                    data.setDashboardSelectState(6);
                }} />
            <TreeItem 
                nodeId="4" 
                label={`Equipment : ${data.equipment}`} 
                className={classes.label} />
        </TreeView>
    );
}
